<template>
  <div>
    <b-container class="d-flex justify-content-center py-2">
      <OnlyView :JobCard="JobCard" @onchange="bomChanged"  @existingPO="existingPO"   />
    </b-container>      
    <b-container class="d-flex justify-content-center py-2">
      <AddBOM :JobCard="JobCard" @onchange="addBomChanged" @newPO="newPO" />
    </b-container> 
  
    <div class="d-flex justify-content-end">
        <b-button variant="primary" class="mt-0 mt-md-2 mr-3" @click="createPurchase()">
          <feather-icon icon="XIcon" class="mr-25" />
          <span>Create PO</span>
        </b-button> 
      </div>

  </div>

      
</template>

<script>
import { BTable, BProgress, BBadge, BContainer, BButton } from "bootstrap-vue";
import AddBOM from "./AddBOM";
import OnlyView from "./OnlyView";

export default {
  components: {
    BTable,
    BContainer,
    AddBOM,
    BButton,
    BProgress,
    OnlyView,
    BBadge,
  },
  data() {
    return {
      addBom: [],
      removeBom: [] ,
      newPOValues:[],
      existingPOValues:[]
    }
  },
  props: {
    JobCard: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    newPO: function(params) {
      this.newPOValues = params;

      console.log("newPOValues params",params);
    },
    existingPO: function(params) {
      this.existingPOValues = params;

      console.log("existing params",params);
    },
    bomChanged(removedBom) {
      this.removeBom = removedBom;
      this.$emit('onchange', this.addBom, this.removeBom);
    },
    addBomChanged(addedBom) {                      
      this.addBom = addedBom;              
      this.$emit('onchange', this.addBom, this.removeBom);
    },
    async createPurchase() {
      // Map the ids of the selected BOM items and join them with commas

      console.log(this.existingPOValues, "View 1");
      console.log(this.newPOValues, "View 2");

      //let isValid = await this.$refs.addBOM.validate();
     // if(isValid){

        const combinedItems = [...this.existingPOValues, ...this.newPOValues];
        console.log("🧡",combinedItems);
        const itemIds = combinedItems.map(item => `${item.id}_${item.quantity}`).join(',');
      //const itemIds = this.selectedBOMItems.map(item => `${item.id}_${item.quantity}`).join(',');
      console.log("🚲",itemIds);
      try {
        // Redirect to the add purchase order page with selected item IDs in the path
        //const itemIds = this.selectedItemIds.join(",");

        if(itemIds == "" || itemIds.includes('null_1'))
        {
          this.$swal({
          title: "No items",
          text: "Please select at least 1 item to initiate purchase order",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });

          return;
        }
        // this.$router.push({
        //   name: "purchaseorders-edit",
        //   query: { itemIds: itemIds },
        // });

      const url = this.$router.resolve({
      name: "purchaseorder-add",
      query: { itemIds: itemIds },
    }).href;
    console.log("url", url)
    window.open(url, "_blank");
    
      } catch (error) {
        this.$swal({
          title: "Error!",
          text: "There was an error navigating to the Purchase Order creation page.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
   // }
    },
  }
};
</script>
